import { render, staticRenderFns } from "./IosPushPreview.vue?vue&type=template&id=064ed78e&scoped=true&"
import script from "./IosPushPreview.vue?vue&type=script&lang=ts&"
export * from "./IosPushPreview.vue?vue&type=script&lang=ts&"
import style0 from "./IosPushPreview.vue?vue&type=style&index=0&id=064ed78e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064ed78e",
  null
  
)

export default component.exports